import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { IEventLog, ILiquidityLog, ITransactionLog } from "./types/_monitoring";
import { PaginationResponse, ResponseData } from "./types/_public";
import moment from "moment-timezone";
const api = new APIClient();

const path = '/monitoring';
const monitoringApi = {
  liquidityLogs(params: any): Promise<AxiosResponse<ResponseData<ILiquidityLog[]> & PaginationResponse, any>> {
    const url = `${path}`
    return api.get(url, params)
  },
  transactionLogs(params: any): Promise<AxiosResponse<ResponseData<ITransactionLog[]> & PaginationResponse, any>> {
    const url = `${path}`
    return api.get(url, params)
  },
  logs(params: any): Promise<AxiosResponse<ResponseData<ILiquidityLog[]> & PaginationResponse, any>> {
    const url = `/secured/token/getTransaction`;
    return api.get(url, {
      ...params,
      fromDate: !!params?.fromDate ? (moment.tz(params?.fromDate, 'YYYY-MM-DD HH:mm', moment.tz.guess()).utc().valueOf() / 1000).toFixed(0) : '',
      toDate: !!params?.toDate ? ((moment.tz(params?.toDate, 'YYYY-MM-DD HH:mm', moment.tz.guess()).utc().valueOf() + 59000) / 1000).toFixed(0) : '',
    });
  },
  eventLogs(params: any): Promise<AxiosResponse<ResponseData<IEventLog[]> & PaginationResponse, any>> {
    const url = `/secured/token/getEventLog`;
    return api.get(url, {
      ...params,
    });
  },
}
export default monitoringApi
